const Loading = (props: { className?: string, height?: number | string, customStyle?: React.CSSProperties }) => {

    return (
        <div className={props.className + " d-flex align-items-center justify-content-center"} style={{ height: props.height }}>
            <div style={props.customStyle} className="lds-default"><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div></div>
        </div>);
};

export default Loading;